export const GET_WALLPAPERS = 'GET_WALLPAPERS'
